import { Icon } from '@components/primitives';

import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';

const ArrowDown: React.FC = () => (
  <Icon name="down" family="antdesign" color={colors.neutral.charcoal} size={scale(18)} />
);

export default ArrowDown;
